import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setNotification } from 'slices/notifySlice';
import { goToLogin } from 'helpers/noSession';

// Components
import LoaderCP from 'components/loader';
import NotifyComponent from 'components/notify';

const NotifyContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { detail } = useSelector((state) => state.detail);
  const { statusNotify } = useSelector((state) => state.notify);
  const { error, type } = useSelector((state) => state.notify.notify);

  useEffect(() => {
    const detailStorage = localStorage.getItem('detail');

    if (detailStorage !== '') {
      const detailStorageId = JSON.parse(detailStorage).id;
      dispatch(setNotification(detailStorageId));
    } else {
      dispatch(setNotification(detail.id));
    }
  }, []);

  const AlreadyNotifyPage = () => navigate(`/subastas/${detail.urlName}/${detail.id}`);
  const ErrorPage = () => navigate('/errorNotify');

  return (
    <>
      <div>
        {statusNotify === 'loading' && <LoaderCP />}
        {statusNotify === 'success' && error === 'Forbidden' && goToLogin()}
        {statusNotify === 'success' && error === false && <NotifyComponent />}
        {statusNotify === 'success' && error && type === 'alreadySuscripted' && AlreadyNotifyPage()}
        {statusNotify === 'success' && error && type === 'General' && ErrorPage()}
      </div>
    </>
  );
};

export default NotifyContainer;
